import API from "@utils/plugins/API";

const InactivityReasonService = {
  all: (params) => {
    return API.get("inactivity-reasons", { params: params });
  },
  create: (name, name_eng, description) => {
    return API.post("inactivity-reasons", {
      name,
      name_eng,
      description,
    });
  },
  update: (id, name, name_eng, description) => {
    return API.put(`inactivity-reasons/${id}`, {
      name,
      name_eng,
      description,
    });
  },
  find: (id) => {
    return API.get(`inactivity-reasons/${id}`);
  },
  destroy: (id) => {
    return API.delete(`inactivity-reasons/${id}`);
  },
};

export default InactivityReasonService;
